<content-state
  [icon]="''"
  [isLoading]="!estimates && !estimatesError && !!countryCode"
  [isEmpty]="!estimates && estimatesError"
>
  @if (estimates) {
    <div class="rounded-lg border border-solid border-default">
      <div class="flex justify-between px-4 py-2 text-base font-semibold text-default">
        <div class="flex flex-col">
          <span>{{ selectedSubscription?.plan?.name }} plan</span>
          <span class="text-sm font-medium text-support">
            @if (selectedSubscription.is_entitled) {
              {{ yearlyBillingToggle.value ? ('billed yearly' | translate) : ('billed monthly' | translate) }}
            } @else {
              {{
                yearlyBillingToggle.value
                  ? ('per active employee/month, billed yearly' | translate)
                  : ('per active employee/month, billed monthly' | translate)
              }}
            }
          </span>
        </div>
        @if (!yearlyBillingToggle.value) {
          <span>{{ planItem?.unit_amount / 100 | subscriptionCurrency }}</span>
        } @else {
          <span>{{ planItem?.unit_amount / 100 / 12 | subscriptionCurrency }}</span>
        }
      </div>
      <div class="flex items-center gap-2 bg-surface px-4 py-2">
        <sb-switch [formControl]="yearlyBillingToggle" [ariaLabel]="'Toggle yearly billing' | translate" />
        <sb-badge [color]="'brand'" [ngClass]="{ 'opacity-50': yearlyBillingToggle.disabled }">
          {{ 'Save up to 10%' | translate }}
        </sb-badge>
        <span class="text-sm font-semibold" [ngClass]="{ 'opacity-50': yearlyBillingToggle.disabled }">
          {{ 'with yearly billing' | translate }}
        </span>
      </div>
    </div>

    <order-summary-content
      class="my-8"
      [estimates]="estimates"
      [countryCode]="countryCode"
      [yearlyBilling]="yearlyBillingToggle.value"
      [hasIntegrationPlus]="hasIntegrationPlus"
      [vatInfo]="vatInfo"
      [isEntitled]="selectedSubscription?.is_entitled"
    />
  }
</content-state>
